<template>
  <span justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn small dark fab outlined v-on="on">
          <v-icon color="green">
            mdi-eye-check-outline
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar  dark color="#286090">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalles del Toca</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">Salir</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card  class="py-0 mb-0 pt-0"  elevation="0">
          <v-row >
            <v-col cols="12" class="py-2 mb-0 pt-0">
              <div class="mx-4 py-3" style="background-color: #F5F5F5">
                <v-card class="mx-4">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-toolbar color="#E0E0E0" dense flat>
                      <h3 class="font-weight-bold ml-15" style="color: #0D47A1">
                        Toca {{ item.numero_completo }}
                      </h3>
                    </v-toolbar>
                    <v-container>
                      <v-row dense class="mt-2">
                        <v-col cols="12" md="6">
                          <v-text-field readonly outlined :value="item.toca.expediente" label="Expediente"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field readonly outlined :value="item.oficio" label="Expediente"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field readonly outlined :value="item.toca.juzgado_data.nombre" label="Juzgado"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field readonly outlined :value="item.toca.juzgado_data.municipio_data.nombre" label="Municipio"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea readonly outlined name="actor" label="Actor" :value="item.actor"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-textarea readonly outlined name="actor" label="Demandado" :value="item.demandado"></v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field readonly outlined :value="item.materia_nombre" label="Materia"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field readonly outlined :value="item.via_nombre" label="Via"></v-text-field>
                        </v-col>
                        <v-col cols="12" :md="(item.accion_reconvencion_nombre) ? 6 : 12">
                          <v-text-field readonly outlined :value="item.accion_nombre" label="Accion"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" v-if="item.accion_reconvencion_nombre">
                          <v-text-field readonly outlined :value="item.accion_reconvencion_nombre" label="Reconvencion"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col cols="12" md="4">
                          <v-text-field readonly outlined :value="item.fecha_recepcion.slice(0,10)" label="Fecha recepción"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" v-if="item.fecha_citacion">
                          <v-text-field readonly outlined :value="item.fecha_citacion.slice(0,10)" label="Fecha citación"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" v-if="item.fecha_turno">
                          <v-text-field readonly outlined :value="item.fecha_turno.slice(0,10)" label="Fecha turno"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" v-if="item.status==10">
                          <v-menu
                            v-model="menu_fecha_citacion"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="fecha_citacion"
                                label="Citación"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="fecha_citacion"
                              @input="menu_fecha_citacion = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="4" v-if="item.status==10">
                          <v-menu
                            v-model="menu_fecha_turno"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="fecha_turno"
                                label="Turno"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="fecha_turno"
                              @input="menu_fecha_turno = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-btn block rounded color="primary">
                        ¿DESEAS AGREGAR NUEVA APELACIÓN PARA EL TOCA?
                      </v-btn>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="mt-6"
                          color="red"
                          text
                          :loading="loading"
                          @click="dialog = false"
                        >Cancelar
                        </v-btn>
                        <v-btn
                          v-if="item.status==10"
                          color="green"
                          text
                          :loading="loading"
                          @click="validate"
                        >GUARDAR
                        </v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-form>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      dialog:false,
      valid: false,
      loading: false,
      menu_fecha_citacion: false,
      menu_fecha_turno: false,
      fecha_citacion: "",
      fecha_turno: "",
      rules: {
        required:v => !!v.trim() || 'Campo requerido',
        requiredSelect:v => !!v|| 'Campo requerido'
      }
    }),
    methods:{
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.save();
        }
      },
      save(){
        this.$store.dispatch("UPDATE_APELACION", { url: "/apelacion/" + this.item.id,
          data:{
            fecha_citacion: this.fecha_citacion,
            fecha_turno: this.fecha_turno
          }
        }).then(response => {
          if (response.status == 200) {
            this.$swal({
              title: "Éxito",
              text: "Fechas asignadas con éxito!!!",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.$emit('reloadTocas');
            this.dialog = false
          }
        })
        .catch(error => {
          console.log(error);
        });
      }
    }
  };
</script>
